<template>
	<section class="register-login">
		<div class="title_wrap">
			<span class="title_name">用户登录</span>
		</div>
		<input type="text" name="username" v-model="username" placeholder="账号">
		<input type="password" name="pwd" v-model="pwd" placeholder="密码">
		<p class="btn-section">
			<button @click="login">确认</button>
		</p>
		<p>
      		<a href="#/regist">没有账号？点此处注册</a>
		</p>
	</section>
</template>

<script>
import { Loading } from 'element-ui'
import axios from 'axios'
import md5 from 'md5'

export default {
  data () {
    return {
      username: '',
      pwd: ''
    }
  },
  mounted(){
    let _t = this
    document.onkeydown=function(ev){
      let event = ev || event
      if(event.keyCode == 13){
        _t.login()
      }
    }
  },
  computed: {
    hmac: function () {
      return md5(this.username + this.pwd)
    }
  },
  created () {
    let _t = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key === 13) {
        _t.login()
      }
    }
  },
  methods: {
    login: function () {
      let _t = this
      let ld = Loading.service({'fullscreen': true, 'text': '数据提交中，请稍后'})
      axios.post(_t.API + '/api/login/', {username: _t.username, pwd: _t.pwd, hmac: _t.hmac, role: 'user'})
        .then(function (resp) {
          if (resp.data.code === '0') {
            _t.$emit('token', resp.data.user.token)
            _t.$emit('role', 'user')
            _t.$router.push('/')
          } else {
            _t.$messageerror(resp.data.msg)
          }

          ld.close()
        })
        .catch(function (error) {
          console.log(error)
          ld.close()
        })
    }
  }
}
</script>

<style scoped lang='stylus'>
@import '~@/common/stylus/index'

.register-login{
	padding: 50px calc((100% - 800px) / 2);
	text-align: center;
}
.title_wrap{
    border-bottom: 1px solid #a3a3a3;
    margin-bottom: 5px;
    text-align: left;
    position: relative;
}
.title_name{
    font-family: sy;
    border-bottom: 4px solid #25335e;
    color: black;
    font-weight:600;
    font-size: 20px;
}
.login_title{
    height: 60px;
    background: black;
    color: white;
    font-family: sybold;
    font-size: 30px;
    text-align: center;
    line-height: 60px;
    margin-bottom: 40px;
}
.register-login>p>button{
    border-radius: 2px;
    background: #25335e;
    height: 40px;
    line-height: 40px;
    color: white;
    font-family: sy;
    width: 300px;
    cursor: pointer;
    font-size: 17px;
}
.register-login>p>a{
  color: #a3a3a3;
  font-size: 17px;
  text-decoration: none;
}
.register-login>p>a:hover{
  color: #25335e;
  text-decoration: underline;
}
.register-login>input[type="password"],.register-login>input[type="text"]{
  height:40px;
  width:100%;
  font-size: 17px;
  margin-top: 30px;
  padding: 0 10px;
  border: 1px solid #E8F0FE;
  border-radius: 2px;
}
.login_line{
  width:0px;
  display:inline-block;
  height:17px;
  border-left: 1px solid black;
  margin: 0px 15px 0px;
  position: relative;
  top: 2px;
}
.btn-section{
  margin: 100px 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// Login.vue?adaaf17e